import produce from "immer"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

const initQidCompanyDocumentState: types.QidCompanyDocumentState = {
    documentList: {},
    documentIds: [],

    reloadList: true,
}

const qidCompanyDocumentReducer = produce((
    draft: types.QidCompanyDocumentState = initQidCompanyDocumentState,
    action: ActionTypes = null,
): types.QidCompanyDocumentState => {
    switch (action.type) {
        case types.QID_COMPANY_DOCUMENT_LIST:
            draft.documentList = action.documentList
            draft.documentIds = action.documentIds
            return draft

        case types.QID_COMPANY_DOCUMENT_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        default:
            return draft
    }
})
export default qidCompanyDocumentReducer
